import React from "react";
import { dispatch } from '@rematch/core';
import ArrangementPane from './ArrangementPane'
import PublishPackPage from './../../drive/layout/PublishPack'
import BreadCrumbsPage from './../../drive/cards/BreadCrumbs'
class PublishPack extends React.Component {

  componentWillMount() {
    dispatch.app.setRouteParams(this.props.match.params)
    dispatch.lifeCycle.setArrangementPaneFlag(false)
    dispatch.lifeCycle.showResourecePane(null);
    dispatch.lifeCycle.displaySecondMenu(null);
    dispatch.createPack.showDuplicateIcon(false);
  }

  render() {
    let height = this.props.componentDesignerDimension;
    return (
      <div className="overflow-hide pad_20" style={{ maxHeight: (height.windowHeight - height.height) - 50 }} >
        <ArrangementPane {...this.props} setPage="Publish" />
        <BreadCrumbsPage {...this.props} />
        <PublishPackPage
          {...this.props}
          selectedPracticeLibrary={this.props.selectedPracticeLibrary}
          loaderStatus={this.props.loaderStatus}
          setUpdatedImageName={this.props.setUpdatedImageName}
          user={this.props.user}
          practiceLabelName={this.props.practiceLabelName}
          selectedOrganisation={this.props.selectedOrganisation}
        />
      </div>
    );
  }
}
export default PublishPack;
